const footerImagesInfo = [
  // {
  //   link: 'https://i.ibb.co/pQT8tLs/facebook-img4.jpg',
  //   alter: 'facebook image 1',
  // },
  // {
  //   link: 'https://i.ibb.co/ck3941R/facebook-img5.jpg',
  //   alter: 'facebook image 2',
  // },
  // {
  //   link: 'https://i.ibb.co/MZXww2T/facebook-img6.jpg',
  //   alter: 'facebook image 3',
  // },
  // {
  //   link: 'https://i.ibb.co/rmxpbLn/facebook-img3.jpg',
  //   alter: 'facebook image 4',
  // },

  {
    link: 'https://i.ibb.co/1nS6gvZ/1.jpg',
    alter: 'instagram image 1',
  },
  {
    link: 'https://i.ibb.co/tH4LX1y/3.jpg',
    alter: 'instagram image 3',
  },
  {
    link: 'https://i.ibb.co/Rh2sd4X/2.jpg',
    alter: 'instagram image 2',
  },
  {
    link: 'https://i.ibb.co/hfCXC6R/4.jpg',
    alter: 'instagram image 4',
  },
];

export default footerImagesInfo;
